import { render, staticRenderFns } from "./CreateGlobalNotes.vue?vue&type=template&id=d3c63b32&"
import script from "./CreateGlobalNotes.vue?vue&type=script&lang=js&"
export * from "./CreateGlobalNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports